import {
  SET_FILTER_SET_CATEGORY_NAME,
} from '../../actions/types';

const initialState = {
  filterSetCategoryName: '',
};

/**
 * Function that takes an action and the previous state of the application and returns the new state
 * @param {object} state - contain initial and final state of data
 * @param {object} action - return the action object
 * @returns {object} updated state
 */
const globalReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_FILTER_SET_CATEGORY_NAME:
      return {
        ...state,
        filterSetCategoryName: action.payload,
      };
    default:
      return state;
  }
};

export default globalReducer;
